import { Injectable } from '@angular/core';
import { AuthRepository } from '@data/auth/auth.repository';
import { PatchAlterarSenhaDto } from '@data/auth/dto';

@Injectable()
export class AlterarSenhaController {
  constructor(private authRepository: AuthRepository) {}

  alterarSenha(data: PatchAlterarSenhaDto) {
    return this.authRepository.patchAlterarSenha(data);
  }
}
